<template>
<div>
    <div style="width: 80%; margin: 15px auto 15px auto">
        <el-input placeholder="请输入候选人姓名进行搜索" v-model="positionName" class="input-with-select" @change="changePostionName">
            <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.name}}，{{item.phone}}</P>
                <p>                      
                    {{item.corporate}},{{item.positionName}},{{item.hrName}},{{item.hrPhone}},{{item.createTime}}
                </p>
                <p>
                    投递人{{item.pubName}}{{item.pubPhone}}标记【{{item.entryPersonStatus === 1 ? "未入职" : item.entryPersonStatus === 2 ? "已面试" : item.entryPersonStatus === 3 ? "已发Offer" : item.entryPersonStatus === 4 ? "已入职" : ""}}】
                </p>
                <p>
                     HR{{item.hrName}}{{item.isGetResume === 0 ? "没有查看" : "查看了"}}联系方式，{{item.hrName}}标记【{{item.jobPublishStatus === 1 ? "未入职" : item.jobPublishStatus === 2 ? "已面试" : item.jobPublishStatus === 3 ? "已发Offer" : item.jobPublishStatus === 4 ? "已入职" : ""}}】
                </p>
            </div>
            <div class="rightDiv">
                <div>
                    <el-button v-if="item.status === '2' || item.status === '1'"  @click="fp(item.id, item.userId)">分配猎头费</el-button>
                    <el-button v-if="item.status === '1' || item.status === '2'"  @click="notacc1(item.id)">未入账</el-button>
                    <el-button  v-if="item.status === '3'" @click="ck(item.jobId, item.userId, item.id)">查看猎头费分配</el-button>
                    <!-- <el-button  v-if="item.status === '4'" @click="notacc(item.id)">标记入账</el-button> -->
                </div>
            </div>
        </div>
    </div>
    <div class="block">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pageNumber"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="pageTotal">
    </el-pagination>
  </div>
    <el-dialog title="分配奖金" :visible.sync="dialogFormVisible">
        <div class="demo-input-suffix">
            候选人月薪（元）：
            <el-input
                placeholder="请输入候选人月薪"
                type="number"
                v-model="inputV1">
            </el-input>
        </div>
        <div class="demo-input-suffix">
            应收猎头费（元）：
            <el-input
                placeholder="根据月薪自动计算应收猎头费"
                type="number"
                readonly
                v-model="inputV2">
            </el-input>
        </div>
        <div class="demo-input-suffix">
            实收猎头费（元）：
            <el-input
                type="number"
                placeholder="请输入实际收到的猎头费"
                v-model="inputV3">
            </el-input>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisibleAction">确 定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="查看猎头费分配" :visible.sync="dialogTableVisible">
        <p>企业实收猎头费：{{Number(totalPutforword) / 100}}元</p>
        <p>企业所得税：{{Number(corporateIncomeTax) / 100}}元</p>
        <p>参与总人数：{{rewardNumber}}人</p>
        <p>个人平均猎头费（税前）：{{Number(rewardMoney) / Number(rewardNumber) / 100}}元</p>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogTableVisibleAction">确 定</el-button>
        </div>
    </el-dialog>
            <el-dialog
    title="提示"
    :visible.sync="dialogVisible3"
    width="30%">
    <span>是否将改职位设置为未入账</span>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible3 = false;notacc()">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'changeAfter',
    props: {},
    data () {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            id: '',
            setId: '',
            setUid: '',
            dialogTableVisible: false,
            dialogFormVisible: false,
            inputV1: '',
            inputV2: '',
            inputV3: '',
            rewardMoney: '',
            corporateIncomeTax: '',
            totalPutforword: '',
            rewardNumber: '',
            dialogVisible3: false,
            settid: ''
            

        }
    },
    watch: {
        inputV1: function () {
            this.inputV2 = Number(this.inputV1) * 10 * 18 / 100  
        }
    },
    created: function () {
        this.id = this.$route.query.id
    },
    methods: {
        notacc1: function (id) {
            this.settid = id
            this.dialogVisible3 = true
        },
        dialogFormVisibleAction: function () {
            if (this.inputV1 === '' || this.inputV3 === '') {
                this.$message({
                        message: '信息填写不完整',
                        type: 'warning'
                    });
                return;
            }
            let m = this.dialogFormVisible
            this.dialogFormVisible = !m
            let that = this
            let data = {id: this.setId, uid: this.setUid,monthlyPay: Number(this.inputV1) * 100, reward: Number(this.inputV3) * 100}
           axios({
                method: 'POST',
                url: Config.path + '/api/v1.0/admin/distribution',
                headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    token: localStorage.getItem('token')},
                params: {},
                data: data,
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                    }
                    return ret
                }],
            }).then(function(response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '分配成功',
                        type: 'warning'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function(error) {
                 // eslint-disable-next-line
                console.log(error)
            })
        },
        dialogTableVisibleAction: function () {
            let m = this.dialogTableVisible
            this.dialogTableVisible = !m
        },
        changePostionName: function () {
            this.pageNumber = 1
            this.getPositionLost()
        },
        getPositionLost: function () {
            let that = this
            let data = {jobId: this.id,pageSize: this.pageSize,pageNumber: this.pageNumber }
            if (this.positionName !== '') {
                data.name = this.positionName
            }
           axios({
                method: 'POST',
                url: Config.path + '/api/v1.0/admin/getrecruitedlist',
                headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    token: localStorage.getItem('token')},
                params: {},
                data: data,
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                    }
                    return ret
                }],
            }).then(function(response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function(error) {
                 // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        notacc: function () {
            let  id = this.settid
            let that = this
           axios({
                method: 'GET',
                url: Config.path + '/api/v1.0/admin/notaccounted',
                headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    token: localStorage.getItem('token')},
                params: {jobCandidateId: id},
                data: {}
            }).then(function(response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function(error) {
                 // eslint-disable-next-line
                console.log(error)
            })
        },
        fp: function (id,uid) {
            this.setId = id
            this.setUid = uid
            this.dialogFormVisible = true
        },
        ck: function (id,uid,resultId) {
            this.setId = id
            this.setUid = uid
            let that = this
           axios({
                method: 'GET',
                url: Config.path + '/api/v1.0/admin/getrewardDetail',
                headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    token: localStorage.getItem('token')},
                params: {jobId: this.setId, uid: this.setUid,resultId: resultId},
                data: {}
            }).then(function(response) {
                if (response.data.success === '1') {
                    that.rewardMoney = response.data.content.rewardMoney
                    that.corporateIncomeTax = response.data.content.corporateIncomeTax
                    that.totalPutforword = response.data.content.totalPutforword
                    that.rewardNumber = response.data.content.rewardNumber
                    that.dialogTableVisibleAction()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function(error) {
                 // eslint-disable-next-line
                console.log(error)
            })
        }
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .itemList{
        margin-top: 20px;
    }

    .itemList .itemDiv{
        background-color: #ffffff;
        width: 80%;
        margin: 0 auto 15px auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 25px;
        border-radius: 8px;
        min-height: 150px;
        box-shadow: 10px 10px 10px rgba(0,0,0,0.5);
    }

    .itemList .itemDiv .leftDiv{
        width: 70%;
    }

    .itemList .itemDiv .leftDiv p{
        font-size: 18px;
        color: #757373;
    }

    .itemList .itemDiv .leftDiv div{
        padding: 30px 0;
    }

    .itemList .itemDiv .rightDiv{
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    .itemList .itemDiv .rightDiv p{
        font-size: 32px;
        color: #1AAD19;
        text-align: center;
    }

    .itemList .itemDiv .rightDiv div{
        padding: 30px 0;
        display: flex;
        flex-direction: row;
        justify-content:space-around;
        align-items: center;
    }

    .block{
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
    }
</style>
